import axiosInstance from './axiosInstance';

// Fetch all contacts
export async function getContacts() {
  try {
    const response = await axiosInstance.get('/api/dashboard/contacts');
    let data = [];

    if (Array.isArray(response.data)) {
      data = response.data;
    } else if (Array.isArray(response.data.contacts)) {
      data = response.data.contacts;
    } else if (Array.isArray(response.data.data)) {
      data = response.data.data;
    } else {
      console.warn('Unexpected contacts response shape:', response.data);
    }

    return data;
  } catch (err) {
    console.error('Error fetching contacts:', err);
    throw new Error('Failed to fetch contacts');
  }
}

// Fetch contact by ID
export const getContactById = (id) => {
  return axiosInstance.get(`/api/dashboard/contacts/${id}`);
};

// Create new contact
export async function createContact(contactData) {
  const response = await axiosInstance.post('/api/dashboard/contacts', contactData);
  return response.data;
}

// Update existing contact
export const updateContact = async (id, updatedData) => {
  console.log('Sending PUT request to update contact:', id, updatedData);
  const response = await axiosInstance.put(`/api/dashboard/contacts/${id}`, updatedData);
  return response.data;
};

// Delete contact by ID
export const deleteContact = (id) => {
  return axiosInstance.delete(`/api/dashboard/contacts/${id}`);
};

// Named object for default export to avoid ESLint warning
const contactsApi = {
  getContacts,
  getContactById,
  createContact,
  updateContact,
  deleteContact,
};

export default contactsApi;
